import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBatteryFull, faCheckCircle, faLeaf, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import SEO from './SEO';

const EnergyStorage = () => {
  return (
    <div className="services">
      <SEO
        title="Energy Storage Solutions | CoreNova Renewable Energy"
        description="Grid-scale and residential energy storage systems: Li-ion, flow batteries, and smart EMS."
        canonical="https://corenovarenewable.com/services/storage"
        keywords="energy storage, battery, lithium-ion, flow battery, EMS, backup"
      />

      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/service hero.png" alt="Energy Storage Services" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>
        <div className="container relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold">Energy Storage Solutions</h1>
          <p className="text-xl md:text-2xl opacity-90">Store energy for reliability, savings, and resilience</p>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-dark mb-4">What We Offer</h2>
              <ul className="space-y-3">
                {[
                  'Lithium-ion and flow battery systems',
                  'Residential and grid-scale deployments',
                  'Smart EMS and monitoring',
                  'Backup power and peak shaving',
                  'Installation, commissioning, and O&M',
                ].map((feature, i) => (
                  <li key={i} className="flex items-center gap-3"><FontAwesomeIcon className="text-primary-green" icon={faCheckCircle} /> <span>{feature}</span></li>
                ))}
              </ul>
            </div>
            <div className="space-y-3">
              <h3 className="text-2xl font-bold text-dark">Benefits</h3>
              {[
                'Energy independence',
                'Grid stability and reliability',
                'Cost optimization and demand charge reduction',
                'Seamless renewable integration',
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-3"><FontAwesomeIcon icon={faLeaf} className="text-primary-green" /><span>{b}</span></div>
              ))}
            </div>
          </div>

          <div className="bg-gray-light p-6 rounded-2xl mt-12">
            <h3 className="text-2xl font-bold text-dark mb-3">Get Started</h3>
            <p className="text-gray mb-4">Find the right storage solution for your facility or home.</p>
            <a href="/contact" className="btn bg-primary-green text-white inline-flex items-center gap-2">
              Talk to an expert <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnergyStorage; 